// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Cape Verde */
const CV = /^(?:(?:36|5[1-389]|9\d)\d{5})$/;

export default CV;
